@if (label) {
  <ion-label [ngClass]="baseCssClass">
    {{ label }}
  </ion-label>
}

<ion-item [disabled]="true" [ngClass]="{ 'ion-margin-vertical': isMediumOrLarge(), hidden: !disabled }" lines="none">
  @if (icon) {
    <ion-icon [name]="icon" slot="start" color="gray"></ion-icon>
  }
  <ion-input
    [ngClass]="baseCssClass"
    [disabled]="true"
    value="{{ readOnlyValue }}"
  placeholder="No {{ label | lowercase }}"></ion-input>
</ion-item>

@if (!disabled) {
  <ion-grid>
    <form [formGroup]="form">
      <ion-row>
        <ion-col [size]="12">
          <ion-row>
            <ion-col>
              <rc-string-form-field [formControlName]="dimensionFormField.height" label="Height"></rc-string-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <rc-string-form-field [formControlName]="dimensionFormField.length" label="Length"></rc-string-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <rc-string-form-field [formControlName]="dimensionFormField.width" label="Width"></rc-string-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <rc-single-select-form-field
                [formControlName]="dimensionFormField.dimensionUnit"
                label="Unit"
              [possibleValues]="getDimensionUnitOptions()"></rc-single-select-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <rc-string-form-field [formControlName]="dimensionFormField.weight" label="Weight"></rc-string-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <rc-single-select-form-field
                [formControlName]="dimensionFormField.weightUnit"
                label="Unit"
              [possibleValues]="getWeightUnitOptions()"></rc-single-select-form-field>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </form>
  </ion-grid>
}
